import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="Seerian" />
        <p className="App-subtitle">For more resources, get in touch.</p>
        <a
          className="App-button"
          href="https://seerian.com/contact"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get In Touch
        </a>
      </header>
      <footer className="App-footer">
        © {new Date().getFullYear()} Seerian. All rights reserved.
      </footer>
    </div>
  );
}

export default App;
